define('views/modules/questionnaire/responses/answers/answer-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/modules/questionnaire/responses/answers/answer-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VAnswerListItem
) {

    var VAnswerList = VList.extend({
        item: VAnswerListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['questionnaire', 'response']));
        },
    });

    return VAnswerList;

});

